import Config from "@app/dev/config/main";

const { registrationFormFiledConfigs } = Config.registrationFormConfigs;

export const checkBoxFields = [
  {
    name: 'rull18',
    enabled: registrationFormFiledConfigs.rull18,
    fieldName: 'rule18',
    label: 'I confirm that I am 18 years of age or older.',
  },
  {
    name: 'termsAndConditions',
    enabled: registrationFormFiledConfigs.termsAndConditions,
    fieldName: 'termsAndConditions',
    label: 'I have read and agree to the Terms & Conditions and Privacy Policy.',
  },
];
